module.exports = __webpack_public_path__ + "static/media/gold-train.55d813ea.gif";